<template>
<header class="menu">
  <div><span></span></div>
  <div><span></span></div>
  <div><span></span></div>
</header>

<h3 class="toTopLogo">
    <router-link :to="{path:'/'}">
      <img class="bg_circle" src="@/assets/images/mv_circle.png">
      <img class="logo_icon" src="@/assets/images/mv_logo.png" alt="MAMA DAYS 総選挙">
    </router-link>
</h3>

<p class="topAnchor" v-on:click="backToTop">
  <img src="@/assets/images/topAnchor.png">
</p>

<div id="navigation">
  <div class="background"></div>
  <div class="fixWrapper">
    <div class="contentsArea">
      <section class="awards_categorys">
        <h3 class="logoTitle">
          <router-link :to="{path:'/'}">
              <img class="bg_circle" src="@/assets/images/mv_circle.png">
              <img class="logo_icon" src="@/assets/images/mv_logo.png" alt="MAMA DAYS 総選挙">
          </router-link>
        </h3>
        <section class="categoryItem">
          <section class="categorys">
            <p class="pageLink">ジャンル</p>
            <ul class="groups">
              <template v-for="category in categoryDefinition.categorys" :key="category.id">
                <router-link v-if="category.id != 'expectation'" :to="{path:'/'+category.id}"><li>{{ category.name }}<span class="bg"><span class="circle"></span></span></li></router-link>
              </template>
            </ul>
          </section>
        </section>
        <div class="services">
          <div class="serviceContainer">
            <p class="mamadays"><a href="https://mamadays.tv/" target="blank"><img src="@/assets/images/nav_mamadays.png" alt="MAMA DAYS"></a></p>
            <p class="mamadaysShop"><a href="https://bit.ly/3lq57YG" target="_blank"><img src="@/assets/images/nav_mamadays_shop.png" alt="MAMA DAYS SHOP"></a></p>
          </div>
          <div class="followlinks">
            <h3 class="en">FOLLOW US!!</h3>
            <ul class="links">
              <li><a class="facebook" href="https://www.facebook.com/MAMADAYS/" target="_blank"></a></li>
              <li><a class="instagram" href="https://www.instagram.com/mamadaystv/" target="_blank"></a></li>
              <li><a class="youtube" href="https://www.youtube.com/channel/UC26H3H7aEUnMwF7hztP07Og" target="_blank"></a></li>
              <li><a class="twitter" href="https://twitter.com/mamadaystv" target="_blank"></a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
</template>

<script>
import util from '@/jsUtil/util'
import { TimelineLite } from 'gsap'
import store from '@/store/index'
import jump from 'jump.js'
export default {
  name: 'Header',

  data () {
    return {
      events: {},
      navProggress: false,
      categoryDefinition: [],
      unsubscribe: null
    }
  },

  mounted () {
    this.toggleLogo();
    const menuEl = document.querySelector(".menu");
    const navEl = document.querySelector("#navigation");
    this.set_nav(menuEl,navEl);
    //headerは基本的にappと同一なので再取得などは行わない。
    this.unsubscribe = store.subscribe((mutation, state) => {
      if(mutation.type == "storeCategoryDefinitions") {
        this.categoryDefinition = state.categoryDefinition
      }
    });
  },

  methods: {
    toggleLogo() {
      // メインビジュアル カラー判定アニメーション
      this.events["toggleLogo"] = () => {
        const currentScroll = util.getScrollTop();
        const flgPosition = 500;
        const logoEl = document.querySelector(".toTopLogo");
        const topAnchorEl = document.querySelector(".topAnchor");
        if(currentScroll >= flgPosition) {
          util.addactive(logoEl);
          util.addactive(topAnchorEl);
        } else {
          util.removeactive(logoEl);
          util.removeactive(topAnchorEl);
        }
      }
      window.addEventListener("scroll", this.events["toggleLogo"]);
    },

    backToTop() {
        jump("body",{ offset: 0, duration: 200 });
    },

    set_nav(menu,nav) {
      let self = this;
      const elbody = document.querySelector("body");
      menu.addEventListener("click",()=>{
        if(menu.classList.contains("active") && !self.navProggress) {
          self.navProggress = true;
          elbody.style.overflow = "visible";
          util.addactive(nav, "deactive");
          util.removeactive(menu);
          util.removeactive(nav);
          setTimeout(()=>{
            nav.style.display = "none";
            self.navProggress = false;
          },800);
        } else if( !self.navProggress ) {
          self.navProggress = true;
          let tl = new TimelineLite({ onComplete: () => {
            util.removeactive(nav, "deactive");
            util.addactive(menu);
            nav.style.display = "block";
            setTimeout(()=>{
              util.addactive(nav);
              self.navProggress = false;
            },200);
            tl = null;
          }});
          tl.set(elbody,{ overflow: "hidden"});
        }
      },false);
    },
    async getCategorysDefinition() {
      const res = await this.axios.get("/dataSources/categoryDefinition.json");
      store.dispatch("setCategoryDefinitions", res.data);
    }
  },

  beforeUnmount() {
    this.unsubscribe();
    this.unsubscribe = null;
  }
}
</script>

<style lang="scss">
.topAnchor {
  position: fixed;
  right: -10%;
  bottom: 12%;
  width: displaysize(88);
  z-index: 5000;
  transform: translate(0);
  will-change: transform,right,opacity;
  backface-visibility:hidden;
  @include transition_anim($propertys: (right,opacity,transform), $duration-time: 1.0s);
  &:hover {
    cursor: pointer;
    transform: scale(1.24);
  }
  &.active {
    right: 4%;
  }
}

.toTopLogo {
  position: fixed;
  width: percent_resize(217,1920);
  min-width: 132px;
  left: -15%;
  top: 40px;
  transform: translate(0,0);
  z-index: 5000;
  will-change: left;
  backface-visibility:hidden;
  @include transition_anim($propertys: (left,opacity), $duration-time: 1.0s);
  &:hover {
    opacity: 0.5;
  }
  &.active {
    left: 40px;
  }
  a {
    width: 100%;
    display: block;
    position: relative;
  }
  &:before {
    @include content_pseudo;
    left: -14.3%;
    top: -8%;
    width: 128%;
    padding-top: 128%;
    z-index: 0;
    background-image: url("~@/assets/images/logo_shadow.png");
    background-size: 100% auto;
    will-change: transfrom, position;
    opacity: 0.8;
    @keyframes rotate_str_shadow_nav {
      0% { 
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    @include animationProp(rotate_str_shadow_nav, 29.0s, 0.0s, linear);
    animation-iteration-count: infinite;
  }
  .logo_icon {
    position: absolute;
    width: percent_resize(166,217);
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    z-index: 1000;
  }
  .bg_circle {
    transform-origin: center;
    will-change: transfrom;
    z-index: 500;
    @keyframes rotate_str {
      0% { 
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    @include animationProp(rotate_str, 29.0s, 0.0s, linear);
    animation-iteration-count: infinite;
  }
}

.menu {
  display: block;
  width: displaysize(123);
  height: displaysize(123);
  position: fixed;
  top: 3%;
  right: 3%;
  z-index: 9500;
  @include hoverlink;
  cursor: pointer;
  background-color: transparent;
  backface-visibility: hidden;
  div {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 55%;
    height: 3px;
    overflow: hidden;
    will-change: transform;
    @include transition_anim($duration-time: 1.0s);
    &:first-child {
      transform: translateY(-1 * displaysize(13));
    }
    &:last-child {
      transform: translateY(displaysize(13));
    }
    span {
      display: block;
      position: absolute;
      top: 0;
      bottom: 0;
      left:0;
      right: 0;
      width: 100%;
      height: 2px;
      background-color: $fontPink;
      will-change: background-color;
      @include transition_anim($duration-time: 1.0s, $propertys: (background-color));
    }
  }


  &.active {
    div {
      span {
        animation: none;
        background-color: $usufulPink;
      }
      &:first-child {
        transform: rotate(35deg);
      }
      &:nth-child(2) {
        opacity: 0;
      }
      &:last-child {
        transform: rotate(-35deg);
      }
    }
  }

  &.forcePink {
    div {
      span {
        background-color: $usufulPink;
      }
    }
  }
}

#navigation {
  // テスト用
  position: fixed;
  display: none;
  z-index: 9200;
  width: 100vw;
  height: 100vh;
  top: 0;
  backface-visibility: hidden;
  .fixWrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    height: 100vh;
    opacity: 0;
    overflow: auto;
    will-change: opacity;
    backface-visibility: hidden;
    @include transition_anim($duration-time: 1.6s);
  }
  .background {
    right: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    opacity: 0;
    background-color: $color_white;
  }
  .contentsArea {
    position: absolute;
    left: 9%;
    @include clearfix;
    width: 80%;
    min-width: 900px;
    padding: 15vh 0 15vh 0;
    margin: 0 auto;
    overflow: visible;
    @include resizebyheight_morethan(970px){
      padding-top: 20vh;
    }
    @include resizebyheight_morethan(1100px){
      padding-top: 25vh;
    }
  }
  &.active {
    .fixWrapper {
      // @include animationProp(openNavigationCon, 0.65s, 0, $cubic-bezir);
      opacity: 1;
      // animation-delay: 0.7s;
    }
    .background {
      // @include animationProp(openNavigation, 0.65s, 0, $cubic-bezir);
      opacity: 1;
      // @include resizebywidth_lessthan($base_resize_size){
      //   @include animationProp(openNavigation_sp, 0.65s, 0, $cubic-bezir);
      // }
    }
  }
  .awards_categorys {
    position: relative;
    width: percent_resize(526,1607);
    margin: 0 auto;
    .services {
      position: absolute;
      width: 88%;
      right: -106%;
      top: 50%;
      transform: translate(0,-40%);
    }
    .serviceContainer {
      display: flex;
      justify-content: space-between;
      p {
        width: percent_resize(192,460);
        img { width: 100% }
        @include hoverlink;
      }
      margin-bottom: percent_resize(51,460);
    }
    .followlinks {
      text-align: center;
      h3 {
        font-size: displaysize(18);
        margin-bottom: percent_resize(18,460);
        color: $fontPink;
      }
      .links {
        display: flex;
        justify-content: space-between;
        width: percent_resize(255,460);
        margin: 0 auto;
        li { 
          width: percent_resize(47,255);
          position: relative;
        }
        a {
          display: block;
          width: 100%;
          padding-top: 100%;
          position: relative;
          transform: translate(0,0) scale(1);
          backface-visibility: hidden;
          will-change: transform;
          @include transition_anim($duration-time: 1.0s);
          &:hover {
            transform: translate(0,0) scale(1.2);
            &:before { opacity: 0; }
            &:after { opacity: 1; }
          }
          &:after, &:before {
            @include content_pseudo;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            z-index: 50;
            will-change: opacity;
            @include transition_anim($duration-time: 1.0s);
          }
          &:before {
            opacity: 1;
          }
          &:after {
            z-index: 100;
          }
          &.facebook { 
            &:before { background: url("~@/assets/images/icons/menu/facebook.png") no-repeat; background-size: 100% auto; }
            &:after { background: url("~@/assets/images/icons/hover/facebook.png") no-repeat; background-size: 100% auto;  }
          }
          &.instagram { 
            &:before { background: url("~@/assets/images/icons/menu/instagram.png") no-repeat; background-size: 100% auto; }
            &:after { background: url("~@/assets/images/icons/hover/instagram.png") no-repeat; background-size: 100% auto;  }
          }
          &.youtube { 
            &:before { background: url("~@/assets/images/icons/menu/youtube.png") no-repeat; background-size: 100% auto; }
            &:after { background: url("~@/assets/images/icons/hover/youtube.png") no-repeat; background-size: 100% auto;  }
          }
          &.twitter { 
            &:before { background: url("~@/assets/images/icons/menu/twitter.png") no-repeat; background-size: 100% auto; }
            &:after { background: url("~@/assets/images/icons/hover/twitter.png") no-repeat; background-size: 100% auto;  }
          }
        }
      }
    }
    .logoTitle {
      position: absolute;
      width: percent_resize(416,526);
      left: -100%;
      top: 50%;
      transform: translate(0,-50%);
      img {
        width: 100%;
      }
      &:before {
        @include content_pseudo;
        left: -14.3%;
        top: -11.5%;
        width: 128%;
        padding-top: 128%;
        z-index: 0;
        background-image: url("~@/assets/images/logo_shadow.png");
        background-size: 100% auto;
        will-change: transfrom, position;
        opacity: 0.8;
        @keyframes rotate_str_shadow {
          0% { 
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        @include animationProp(rotate_str_shadow, 32.0s, 0.0s, linear);
        animation-iteration-count: infinite;
      }
      .logo_icon {
        position: absolute;
        width: 78%;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        z-index: 1000;
      }
      .bg_circle {
        will-change: transfrom;
        @keyframes rotate_str {
          0% { 
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        @include animationProp(rotate_str, 32.0s, 0.0s, linear);
        animation-iteration-count: infinite;
        z-index: 500;
      }
    }
    .categorys {
      width: 100%;
      .groups {
        li {
          font-size: displaysize(33);
          font-family: 'M PLUS Rounded 1c', sans-serif;
          color: $fontPink;
          &:hover {
            .bg {
              .circle {
                background-color: $fontPink;
                width: 160%;
                padding-top: 160%;
                height: auto;
                top: -32%;
                left: -29%;
              }
              &:after {
                opacity: 0.0; 
              }
              &:before { 
                opacity: 1.0; 
              }
            }
            border-top: 1px solid #000000!important;
            border-bottom: 1px solid #000000!important;
            z-index: 1000!important;
          }
          .bg {
            display: block;
            position: absolute;
            width: percent_resize(40,630);
            padding-top: percent_resize(40,630);
            right: 4%;
            top: 50%;
            transform: translate(0,-50%);
            .circle {
              display: block;
              position: absolute;
              width: 100%;
              padding-top: 100%;
              border-radius: 50%;
              border: 1px solid $fontPink;
              left: 0;
              top: 0;
              z-index: 0;
              will-change: background-color,width,padding-top,left,top;
              background-color: transparent;
              @include transition_anim($duration-time: 0.8s, $propertys: (background-color,width,padding-top,left,top));
              backface-visibility: hidden;
            }
            &:after {
              @include content_pseudo;
              width: 56%;
              height: 56%;
              background-size: 100% auto;
              left: 55%;
              top: 52%;
              transform: translate(-50%,-50%);
              z-index: 100;
              background-image: url("~@/assets/images/icon_arrow_pink.png");
              background-repeat: no-repeat;
              background-size: 100% auto;
              will-change: opacity;
              @include transition_anim($duration-time: 1.0s, $propertys: (opacity));
            }
            &:before {
              @include content_pseudo;
              width: 56%;
              height: 56%;
              background-size: 100% auto;
              left: 55%;
              top: 52%;
              transform: translate(-50%,-50%);
              background-image: url("~@/assets/images/icon_arrow_pink_hover.png");
              background-repeat: no-repeat;
              background-size: 100% auto;
              z-index: 200;
              opacity: 0;
              will-change: opacity;
              @include transition_anim($duration-time: 1.0s, $propertys: (opacity));
            }
          }
        }
      }
    }
  }
}

@include resizebywidth_lessthan($base_resize_size){
  .toTopLogo {
    // width: 20%;
    // left: -25%;
    // top: 8%;
    // &:hover {
    //   opacity: 0.5;
    // }
    // &.active {
    //   left: 3%;
    // }
    display: none;
  }
  .topAnchor {
    right: -20%;
    bottom: 5%;
    width: 11%;
    z-index: 5000;
    &.active {
      right: 5%;
    }
  }
  .menu {
    right: 1%;
    top: 1%;
  }
  #navigation {
    .fixWrapper {
      .contentsArea {
        width: 100%;
        min-width: auto;
        max-width: initial;
        transform: none;
        left: auto;
        overflow: hidden;
        padding: percent_resize(78,375) 0 22% 0!important;
        .awards_categorys {
          width: 100%;
          .logoTitle {
            position: relative;
            width: percent_resize(191,375);
            left: auto;
            top: auto;
            transform: none;
            margin: 0 auto percent_resize(40,375) auto;
          }
          .categoryItem {
            width: percent_resize(332,375);
            margin: 0 auto;
            .categorys {
              width: 100%;
              .pageLink {
                font-family: 'M PLUS Rounded 1c', sans-serif;
                font-size: 4.0vw;
              }
              .groups {
                li {
                  font-size: 5.1vw;
                  .bg {
                    .circle {
                      border: 2px solid $fontPink;
                    }
                    &:before,&:after {
                        left: 58%;
                        top: 55%;
                    }
                  }
                }
              }
            }
          }
          .services {
            position: relative;
            top: auto;
            right: auto;
            transform: none;
            width: percent_resize(311,375);
            margin: percent_resize(55,375) auto percent_resize(70,375) auto;
            .followlinks {
              h3 {
                font-size: 4.0vw;
                margin-bottom: percent_resize(20,311);
              }
              .links {
                width: percent_resize(255,311);
                margin: 0 auto;
              }
            }
          }
        }
      }
    }
  }
}
</style>
